import { useEffect } from "react";
import { Grid, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  JOrder,
  resetForm,
  setChangePosDialog,
} from "../../../../app/slices/jomla/orderSlice";
import { SelectPos } from "../../../../components/Selectors/SelectPos";
import { HiOutlineBuildingStorefront } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const ChangePosForm = (props) => {
  const dispatch = useDispatch();

  const _JOrder = useSelector((state) => state.jOrder.changePos);
  const _POS = useSelector((state) => state.pointOfsales.posesList.data);
  const _SearchBody = useSelector((state) => state.jOrder.searchBody);

  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: _JOrder.form,
  });

  const onSubmit = (data) => {
    dispatch(
      JOrder.changePos(
        _JOrder.form.order_id,
        {
          user_id: data.user_id,
          note: data.note,
        },
        _SearchBody,
        props.orderDetails
      )
    );
  };

  useEffect(() => {
    reset({ ..._JOrder.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_JOrder.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setChangePosDialog({}));
  };

  return (
    <FormDialog
      open={_JOrder.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineBuildingStorefront />}
      title={"تغيير نقطة البيع للطلب"}
      subtitle="اختر نقطة البيع الجديدة للطلب ثم احفظ التغييرات"
      onSubmit={handleSubmit(onSubmit)}
      saving={_JOrder.loading}
      loading={_JOrder.loading}
    >
      <SectionCard icon={<HiOutlineBuildingStorefront />} title="نقطة البيع">
        <Grid item xs={12}>
          <Controller
            name="user_id"
            control={control}
            render={({ field }) => (
              <SelectPos
                {...field}
                required
                onChange={(e, newValue) => {
                  setValue("user_id", newValue ? newValue.user_id : null);
                }}
                value={
                  _POS.filter((x) => x.user_id === field.value)[0] ?? null
                }
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name={"note"}
            render={({ field }) => (
              <TextField
                size="small"
                label="الملاحظات"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default ChangePosForm;
